export const SHAREHOLDERS = "SHAREHOLDERS"
export const SHAREHOLDERS_SUCCESS = "SHAREHOLDERS_SUCCESS"
export const SHAREHOLDERS_FAILED = "SHAREHOLDERS_FAILED"

export const SHAREHOLDERSLIST = "SHAREHOLDERSLIST"
export const SHAREHOLDERSLIST_SUCCESS = "SHAREHOLDERSLIST_SUCCESS"
export const SHAREHOLDERSLIST_FAILED = "SHAREHOLDERSLIST_FAILED"

export const ROLESLIST = "ROLESLIST"
export const ROLESLIST_SUCCESS = 'ROLESLIST_SUCCESS'
export const ROLESLIST_FAILURE = 'ROLESLIST_FAILURE'

export const ADDSHAREHOLDERS = "ADDSHAREHOLDERS"
export const ADDSHAREHOLDERS_SUCCESS = "ADDSHAREHOLDERS_SUCCESS"
export const ADDSHAREHOLDERS_FAILED = "ADDSHAREHOLDERS_FAILED"

export const UPDATESHAREHOLDERS = 'UPDATESHAREHOLDERS'
export const UPDATE_SHAREHOLDERS_SUCCESS = 'UPDATE_SHAREHOLDERS_SUCCESS'
export const UPDATE_SHAREHOLDERS_FAILURE = 'UPDATE_SHAREHOLDERS_FAILURE'

export const SHAREHOLDERSGROUPSLIST = "SHAREHOLDERSGROUPSLIST"
export const SHAREHOLDERSGROUPSLIST_SUCCESS = "SHAREHOLDERSGROUPSLIST_SUCCESS"
export const SHAREHOLDERSGROUPSLIST_FAILED = "SHAREHOLDERSGROUPSLIST_FAILED"

export const ADDSHAREHOLDERSGROUP = "ADDSHAREHOLDERSGROUP"
export const ADDSHAREHOLDERSGROUP_SUCCESS = "ADDSHAREHOLDERSGROUP_SUCCESS"
export const ADDSHAREHOLDERSGROUP_FAILED = "ADDSHAREHOLDERSGROUP_FAILED"

export const UPDATESHAREHOLDERSGROUP = 'UPDATESHAREHOLDERSGROUP'
export const UPDATE_SHAREHOLDERSGROUP_SUCCESS = 'UPDATE_SHAREHOLDERSGROUP_SUCCESS'
export const UPDATE_SHAREHOLDERSGROUP_FAILURE = 'UPDATE_SHAREHOLDERSGROUP_FAILURE'